import styled from "styled-components";
import Colors from "../../Constant/Colors";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow-y: scroll;
  padding: 10px 0px;

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media only screen and (max-width: 900px) {
    /* flex-direction: column; */
  }
`;
export const MainDiv = styled.div`
  width: 70%;
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const RightContent = styled.div`
  width: 35%;
  height: 100vh;
  overflow:scroll ;
  /* min-width: 120px; */
`;
export const ContactContent = styled.div`
  width: 95%;
  min-width: 100px;
  background-color: ${Colors.primary};
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
`;

export const EachContact = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 10px;
`;
export const FaqContent = styled.div`
  width: 95%;
  min-width: 100px;
  padding: 20px;
  box-sizing: border-box;
`;

export const EachFaq = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 10px;
  height: ${(props) => (props?.isOpened ? null : "40px")};
  overflow: hidden;
  box-sizing: border-box;
  transition: transition 1000ms ease;
  cursor: pointer;
`;
